module.exports = __webpack_public_path__ + "fonts/dFanZfeM_74wlPZtksIFaj8CVHaZWXB3X6_0fw.woff2";